

import axios from 'axios'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, ArrowLeft, ArrowUpRight, ChevronDown } from 'lucide-react';

export default function Login() {
    const navigate = useNavigate();
    const [sucursal, setSucursal] = useState('');
    const [cuit, setCuit] = useState('')
    const [password, setPassword] = useState('')
    const [errorMensaje, setErrorMensaje] = useState('')
    const [cargando, setCargando] = useState(false)
    const [showPassword, setShowPassword] = useState(false);

    const sucursales = [
        { nombre: 'Buchardo', value: 'buch' },
        { nombre: 'Integral Sur', value: 'sur' },
        { nombre: 'Laboulaye', value: 'lab' },
        // { nombre: 'Melo', value: 'mel' },
        { nombre: 'Pueblo Italiano', value: 'ita' },
        // { nombre: 'Serrano', value: 'ser' },
        { nombre: 'Villa Valeria', value: 'val' },
    ];

    const handleSucursalChange = (e) => { setSucursal(e.target.value); setErrorMensaje(''); };
    const handleCuitChange = (e) => { setCuit(e.target.value.trim()); setErrorMensaje(''); }
    const handlePasswordChange = (e) => { setPassword(e.target.value.trim()); setErrorMensaje(''); }
    const toggleShowPassword = () => { setShowPassword(!showPassword); }

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!sucursal) { setErrorMensaje('¡Seleccione Sucursal!'); return; }
        if (!cuit) { setErrorMensaje('¡Ingrese su CUIT!'); return; }
        if (!password) { setErrorMensaje('¡Ingrese su Contraseña!'); return; }

        setCargando(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login/${sucursal}`, { cuit, password })
            if (response.status === 200) {
                const { token, isAdmin } = response.data
                localStorage.setItem('auth_cliente', token);
                localStorage.setItem('sucursal', sucursal);
                localStorage.setItem('admin', isAdmin);
                navigate('/layoutCliente');
            }
        } catch (error) {
            setErrorMensaje(error.response?.status === 401 ? error.response.data.message : 'Error al iniciar sesión.');
        } finally {
            setCargando(false);
        }
    }

    return (
        <div className="min-h-screen bg-[#050f08] flex overflow-hidden">

            {/* PANEL IZQUIERDO — branding */}
            <div className="hidden lg:flex flex-col justify-between w-1/2 px-16 py-12 relative border-r border-white/5">
                <div className="absolute inset-0">
                    <img
                        src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80"
                        alt=""
                        className="w-full h-full object-cover opacity-10"
                    />
                    <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, #050f08 40%, transparent 100%)' }} />
                </div>

                <div className="relative z-10">
                    <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
                        <div className="w-9 h-9 rounded-xl border border-white/10 flex items-center justify-center">
                            <img src="logo-integ.png" alt="Logo" className="w-6 h-6 object-contain" />
                        </div>
                        <div>
                            <div className="text-white text-[12px] font-black tracking-widest uppercase">Integral Agropecuaria</div>
                            <div className="text-[#c9a84c]/50 text-[8px] tracking-[0.5em] uppercase font-bold">Conocernos rinde</div>
                        </div>
                    </div>
                </div>

                <div className="relative z-10">
                    <h2 className="text-5xl font-black tracking-tighter leading-none mb-6 text-white">
                        Tu campo,<br />
                        <span style={{ WebkitTextStroke: '1px rgba(255,255,255,0.2)', color: 'transparent' }}>siempre</span><br />
                        <span className="text-[#c9a84c]">conectado.</span>
                    </h2>
                    <p className="text-white/25 text-sm leading-relaxed max-w-xs">
                        Portal exclusivo para productores. Información actualizada, acceso simple y seguro.
                    </p>

                    <div className="flex flex-col gap-3 mt-10">
                        {[
                            "Datos actualizados en tiempo real",
                            "Acceso desde cualquier dispositivo",
                            "Historial completo de operaciones",
                        ].map((item) => (
                            <div key={item} className="flex items-center gap-3">
                                <div className="w-1 h-1 rounded-full bg-[#c9a84c]" />
                                <span className="text-white/30 text-[11px] uppercase tracking-widest font-bold">{item}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="relative z-10 flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#c9a84c] animate-pulse" />
                    <span className="text-white/15 text-[9px] uppercase tracking-[0.5em] font-bold">7 sucursales activas en Córdoba</span>
                </div>
            </div>

            {/* PANEL DERECHO — formulario */}
            <div className="flex-1 flex flex-col justify-center items-center px-8 py-12 relative">

                {/* Glow decorativo */}
                <div className="absolute top-0 right-0 w-96 h-96 rounded-full pointer-events-none"
                    style={{ background: 'radial-gradient(circle, rgba(201,168,76,0.05) 0%, transparent 70%)' }} />

                <div className="w-full max-w-sm">

                    {/* HEADER MOBILE */}
                    <div className="lg:hidden flex items-center gap-3 mb-10 cursor-pointer" onClick={() => navigate('/')}>
                        <div className="w-8 h-8 rounded-xl border border-white/10 flex items-center justify-center">
                            <img src="logo-integ.png" alt="Logo" className="w-5 h-5 object-contain" />
                        </div>
                        <div className="text-white text-[11px] font-black tracking-widest uppercase">Integral Agropecuaria</div>
                    </div>

                    {/* TÍTULO */}
                    <div className="mb-10">
                        <div className="text-[#c9a84c] text-[9px] font-black uppercase tracking-[0.6em] mb-3">Portal exclusivo</div>
                        <h1 className="text-3xl font-black tracking-tighter text-white">Bienvenido</h1>
                        <p className="text-white/25 text-sm mt-2">Ingresá con tus credenciales para continuar.</p>
                    </div>

                    {/* FORMULARIO */}
                    <form onSubmit={handleLogin} className="space-y-5">

                        {/* SUCURSAL */}
                        <div className="space-y-2">
                            <label className="text-white/30 text-[9px] uppercase tracking-[0.4em] font-black">Sucursal</label>
                            <div className="relative">
                                <select
                                    onChange={handleSucursalChange}
                                    value={sucursal}
                                    className="w-full bg-white/[0.03] border border-white/8 hover:border-white/15 focus:border-[#c9a84c]/50 text-white rounded-xl py-3.5 px-4 text-sm focus:outline-none transition-all appearance-none cursor-pointer"
                                    required
                                >
                                    <option value="" disabled className="bg-[#050f08] text-white/40">Seleccionar sucursal...</option>
                                    {sucursales.map((suc) => (
                                        <option key={suc.value} value={suc.value} className="bg-[#0a1f0d] text-white">{suc.nombre}</option>
                                    ))}
                                </select>
                                <ChevronDown size={14} className="absolute right-4 top-1/2 -translate-y-1/2 text-white/20 pointer-events-none" />
                            </div>
                        </div>

                        {/* CUIT */}
                        <div className="space-y-2">
                            <label className="text-white/30 text-[9px] uppercase tracking-[0.4em] font-black">CUIT</label>
                            <input
                                onChange={handleCuitChange}
                                type="text"
                                maxLength={11}
                                className="w-full bg-white/[0.03] border border-white/8 hover:border-white/15 focus:border-[#c9a84c]/50 text-white rounded-xl py-3.5 px-4 text-sm focus:outline-none transition-all placeholder:text-white/15"
                                placeholder="00-00000000-0"
                                required
                            />
                        </div>

                        {/* CONTRASEÑA */}
                        <div className="space-y-2">
                            <label className="text-white/30 text-[9px] uppercase tracking-[0.4em] font-black">Contraseña</label>
                            <div className="relative">
                                <input
                                    onChange={handlePasswordChange}
                                    type={showPassword ? "text" : "password"}
                                    className="w-full bg-white/[0.03] border border-white/8 hover:border-white/15 focus:border-[#c9a84c]/50 text-white rounded-xl py-3.5 px-4 text-sm focus:outline-none transition-all placeholder:text-white/15"
                                    placeholder="••••••••"
                                    required
                                />
                                <button type="button" onClick={toggleShowPassword}
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-white/15 hover:text-[#c9a84c] transition-colors">
                                    {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                                </button>
                            </div>
                        </div>

                        {/* ERROR */}
                        {errorMensaje && (
                            <div className="bg-red-500/5 border border-red-500/20 rounded-xl p-3.5 flex items-center gap-3">
                                <div className="w-1.5 h-1.5 rounded-full bg-red-400 flex-shrink-0" />
                                <p className="text-red-400 text-[10px] font-black uppercase tracking-wider">{errorMensaje}</p>
                            </div>
                        )}

                        {/* BOTONES */}
                        <div className="pt-2 space-y-3">
                            <button
                                type="submit"
                                disabled={cargando}
                                className="w-full group flex items-center justify-center gap-3 bg-[#c9a84c] hover:bg-[#ddb94e] text-[#050f08] font-black uppercase text-[11px] tracking-widest py-4 rounded-xl transition-all duration-300 disabled:opacity-40 active:scale-[0.98]"
                            >
                                {cargando ? (
                                    <span className="flex items-center gap-2">
                                        <span className="w-3.5 h-3.5 border-2 border-[#050f08]/30 border-t-[#050f08] rounded-full animate-spin" />
                                        Procesando...
                                    </span>
                                ) : (
                                    <>
                                        Ingresar al portal
                                        <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                                    </>
                                )}
                            </button>

                            <button
                                type="button"
                                onClick={() => navigate('/')}
                                className="w-full flex items-center justify-center gap-2 text-white/20 hover:text-white/50 font-bold uppercase text-[10px] tracking-widest py-3 rounded-xl transition-all hover:bg-white/[0.02]"
                            >
                                <ArrowLeft size={12} />
                                Volver al inicio
                            </button>
                        </div>
                    </form>

                    <div className="mt-10 pt-8 border-t border-white/5 text-center">
                        <p className="text-white/10 text-[9px] uppercase tracking-[0.4em] font-bold">
                            © {new Date().getFullYear()} Integral Agropecuaria S.R.L
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}